import { Button } from '@acorns/web-components'
import styled from 'styled-components'

import { style } from 'theme'

const StyledButton = styled(Button)`
  font-weight: 600;
  width: 220px;
  margin: auto;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    width: 100%;
  }
`

export { StyledButton }
